"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5m.124 14.438c-3.415 0-6.188-2.772-6.188-6.188s2.772-6.188 6.188-6.188c1.671 0 3.069.613 4.139 1.615l-1.757 1.708c-.445-.421-1.225-.916-2.382-.916-2.048 0-3.719 1.702-3.719 3.787s1.671 3.787 3.719 3.787c2.37 0 3.242-1.64 3.403-2.611h-3.409v-2.308h5.792c.087.39.155.755.155 1.268 0 3.533-2.37 6.045-5.94 6.045z"
}), 'GoogleRing');
//# sourceMappingURL=index.js.map